import { SxProps } from '@mui/material';
import { black1, grey9, yellow, yellow1 } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');

export const line: SxProps = {
  width: '100%',
  height: '8px',
  background: yellow,
};

export const header: SxProps = {
  height: '102px',
  boxSizing: 'border-box',
  borderBottom: '1px solid rgba(20, 25, 31, 0.06)',
  display: 'flex',
};

export const logoSide: SxProps = {
  padding: '29px 41px 29px 60px',
  height: '102px',
  display: 'flex',
  justifyContent: 'space-between',
  width: '26%',
  alignItems: 'center',
  borderRight: '1px solid rgba(20, 25, 31, 0.06)',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    padding: '29px 0px 29px 28px',
    borderRight: '0px solid rgba(20, 25, 31, 0.06)',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '29px 0px 29px 20px',
  },
};

export const notif: SxProps = {
  background: yellow1,
  display: 'flex',
  borderRadius: '30px',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
  height: '20px',
  p: '3px 8px 0 8px',
};

export const notifText: SxProps = {
  fontSize: '12px',
  fontWeight: '700',
  fontFamily: 'Yelo',
  lineHeight: 1,
};

export const headerBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: '36px',

  [theme.breakpoints.down('lg')]: {
    gap: '0px',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
    width: '100%',
  },
};
export const headerBtnsBox: SxProps = {
  display: 'flex',
  gap: '12px',

  [theme.breakpoints.down('md')]: {
    mt: '25px',
  },
};

export const drawerHeader: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
    p: '26px 20px 0px 20px',
  },
};

export const infoSide: SxProps = {
  p: '28px 48px 28px 26px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '74%',

  [theme.breakpoints.up('md')]: {
    p: '28px 48px 28px 26px',
  },
  [theme.breakpoints.down('lg')]: {
    p: '28px 20px 28px 20px',
  },
  [theme.breakpoints.down('md')]: {
    width: 'fit-content',
    p: '28px 28px 28px 0px',
    justifyContent: 'flex-end',
    flexDirection: 'row-reverse',
  },
  [theme.breakpoints.down('sm')]: {
    p: '28px 20px 28px 0px',
  },
};

export const notifBox: SxProps = {
  display: 'flex',
  gap: '4px',
  borderRight: '1px solid rgba(20, 25, 31, 0.06)',
  pr: '16px',
  alignItems: 'center',
  mr: '16px',

  [theme.breakpoints.down('lg')]: {
    pr: '12px',
    mr: '12px',
  },
  [theme.breakpoints.down('md')]: {
    width: '96px',
  },
  [theme.breakpoints.down('sm')]: {
    width: 'auto',
  },
};

export const userProfileBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  height: '24px',
  p: 0,
  pl: '4px', // bildirishler gelenden sonra sil (after mailbox)

  '& .MuiSvgIcon-root': {
    height: '24px',
    width: '24px',
  },
  [theme.breakpoints.down('md')]: {
    ml: '26px',
  },
  [theme.breakpoints.down('sm')]: {
    ml: '0px',
  },
};

export const userName: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '16px',
  fontWeight: '500',
  textTransform: 'uppercase',
  lineHeight: 1,
  color: black1,
  width: '150px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

export const menuItems: SxProps = {
  color: black1,
  display: 'flex',
  gap: '12px',
  fontSize: '15px',
  fontFamily: 'Yelo',
  p: '12px 16px',

  '&:hover': {
    color: `${black1} !important`,
    background: `${grey9} !important`,
  },
};

export const signBox = (drawer: boolean) => ({
  display: drawer ? 'none' : 'flex',
  gap: '8px',
  p: '8px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    p: '0px',
  },
});

export const permissionBox: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',

  borderRight: '1px solid rgba(20, 25, 31, 0.06)', // bildirishler gelenden sonra sil (after mailbox)
  pr: '12px', // bildirishler gelenden sonra sil (after mailbox)

  [theme.breakpoints.down('md')]: {
    fontSize: '13px',
    mt: '25px',
    width: '100%',
    '& .MuiSvgIcon-root': {
      height: '20px',
      width: '20px',
    },
  },
};

export const signText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '16px',
  fontWeight: 600,
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '13px',
    display: 'block',
  },
};

export const signatureBox: SxProps = {
  display: 'flex',
  gap: '36px',
  [theme.breakpoints.down('lg')]: {
    gap: '4px',
  },
};
